import { axios, Response } from '..'
import { FolderVisibility } from './create-template'

export interface ResponseRenameTemplatesFolder {
  id: string
  name: string
  parentFolderId: string
  folders: string[]
  folderVisibility: FolderVisibility
}

export interface BodyRenameTemplatesFolder {
  id?: string
  name?: string
  parentFolderId?: string | null
  folderVisibility?: FolderVisibility
}

export const renameTemplatesFolder = async ({
  id,
  name,
  parentFolderId,
  folderVisibility
}: BodyRenameTemplatesFolder): Response<BodyRenameTemplatesFolder> => {
  const body = {
    name: name,
    parentFolderId: parentFolderId,
    folderVisibility: folderVisibility
  }
  return axios.put(`/v1/template-gallery/${id}`, body)
}
